"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const constants_1 = require("@/common/constants");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'MoonGlobalParameterValue',
    props: {
        moonData: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isMax() {
            return (this.moonData.habitatRate >= constants_1.MAXIMUM_HABITAT_RATE &&
                this.moonData.miningRate >= constants_1.MAXIMUM_MINING_RATE &&
                this.moonData.logisticsRate >= constants_1.MAXIMUM_LOGISTICS_RATE);
        },
    },
});
